(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', 'prop-types', 'resize-observer-polyfill'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('resize-observer-polyfill'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.resizeObserverPolyfill);
    global.ResizeObserver = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _resizeObserverPolyfill) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ResizeObserver = function (_PureComponent) {
    _inherits(ResizeObserver, _PureComponent);

    function ResizeObserver() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ResizeObserver);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResizeObserver.__proto__ || Object.getPrototypeOf(ResizeObserver)).call.apply(_ref, [this].concat(args))), _this), _this._container = null, _this._target = null, _this._observer = null, _this._height = null, _this._width = null, _this._measure = function (entries) {
        if (!_this._observer || !_this._target) {
          return;
        }
        var _this$props = _this.props,
            watchHeight = _this$props.watchHeight,
            watchWidth = _this$props.watchWidth,
            onResize = _this$props.onResize;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {

          for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var entry = _step.value;

            if (!entry) {
              return;
            }

            var _entry$contentRect = entry.contentRect,
                height = _entry$contentRect.height,
                width = _entry$contentRect.width;

            if (watchHeight && height !== _this._height || watchWidth && width !== _this._width) {
              _this._height = height;
              _this._width = width;
              onResize({ height: height, width: width });
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }, _this._handleRef = function (container) {
        if (container) {
          _this._container = container;
          _this._target = _this._getTarget(container, _this.props.target);
          _this._observer = new _resizeObserverPolyfill2.default(_this._measure);

          if (_this._target) {
            _this._observer.observe(_this._target);
          }
        } else {
          if (_this._observer) {
            _this._observer.disconnect();
          }

          _this._container = null;
          _this._target = null;
          _this._observer = null;
          _this._height = null;
          _this._width = null;
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ResizeObserver, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var target = this.props.target;

        var nextTarget = nextProps.target;
        if (target === nextTarget) {
          return;
        } else if (nextTarget) {
          if (this._target) {
            this._observer.unobserve(this._target);
          }
          this._target = this._getTarget(this._container, nextTarget);
          this._observer.observe(this._target);
        }
      }
    }, {
      key: '_getTarget',
      value: function _getTarget(container, target) {
        if (target === null || target && typeof target !== 'string') {
          return target;
        }

        var t = null;
        if (target) {
          t = document.getElementById(target) || document.querySelector(target);
        } else {
          t = container.parentNode;
        }

        if (!t) {
          throw new Error('An HTMLDOMNode is required as the `ResizeObserver`\'s watch target but none were provided/found. ' + ('Please update the target prop to find a valid node since the provided target is invalid. `' + target + '`.'));
        }

        return t;
      }
    }, {
      key: 'render',
      value: function render() {
        var Component = this.props.component;

        return _react2.default.createElement(Component, { ref: this._handleRef, 'aria-hidden': true });
      }
    }]);

    return ResizeObserver;
  }(_react.PureComponent);

  ResizeObserver.propTypes = {
    /**
     * Boolean if the height should be watched for the resize target.
     */
    watchHeight: _propTypes2.default.bool,

    /**
     * Boolean if the width should be watched for the resize target.
     */
    watchWidth: _propTypes2.default.bool,

    /**
     * An optional target that should be used for detecting resize events. This can either
     * be a HTMLDOMNode or a string to use with `document.getElementById` or `document.querySelector`.
     *
     * If this prop is not provided and not null, it will default to the parent node of this component.
     * If the provided `target={null}`, the observer will not begin until the `target` is `undefined` or
     * it has been correctly passed a target string or object.
     */
    target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),

    /**
     * The component to be rendered as. This should normally just be the default `span`, but there are cases
     * where the component should be switched to something else for valid html.
     */
    component: _propTypes2.default.string,

    /**
     * A function to call when the height or width has been changed and that attribute is being watched.
     * The callback will include the current height and width of the target.
     *
     * ```js
     * onResize({ height: nextHeight, width: nextWidth });
     * ```
     */
    onResize: _propTypes2.default.func.isRequired
  };
  ResizeObserver.defaultProps = {
    watchHeight: false,
    watchWidth: false,
    component: 'span'
  };
  exports.default = ResizeObserver;
});


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/Helpers/ResizeObserver.js
// module id = ./node_modules/react-md/lib/Helpers/ResizeObserver.js
// module chunks = 14908075825222668000